import { CurrencyPipe } from '@angular/common';
import { inject, Component, ElementRef, HostBinding, HostListener, Injectable, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as d3 from "d3";
import { axisTickFormat } from '../chart-axis-format';
import { BasicPopupGridComponent, BasicPopupGridDialogData } from 'src/app/components/shared/grid/basic-popup-grid/basic-popup-grid.component';
import { AggregationConfig, DataAggregationService } from "src/app/services/data-aggregation.service";
import { DataService } from 'src/app/services/data.service';
import { DialogService } from 'src/app/services/dialog.service';
import { DynamicCustomTooltipService } from 'src/app/services/dynamic-custom-tooltip.service';
import { FilterService } from 'src/app/services/filter.service';
import { NewFilterService } from 'src/app/services/new-filter.service';
import { NoDataNotifierService } from 'src/app/services/no-data-notifier.service';
@Injectable({
  providedIn: 'root'
})
@Component({
    selector: 'slope-chart',
    templateUrl: './slope-chart.component.html',
    styleUrls: ['./slope-chart.component.scss'],
    standalone: false
})
export class SlopeChartSComponent implements OnInit, OnChanges, OnDestroy {
  private readonly noDataNotifier = inject(NoDataNotifierService);


  @ViewChild('barContainer', { static: true }) barContainer!: ElementRef
  @ViewChild('lineChart') lineChart!: ElementRef;
  @ViewChild('SlopeChart', { static: true }) slopeChartContainer!: ElementRef;
  // @ViewChild("prompt", { static: true }) prompt!: ElementRef;
  @Input('data') data: any
  @Input('pageKey') pageKey: any
  @Input('item') item: any
  @Input('config') config: any
  @Input('headerConfig') headerConfig: any
  @Input('heading') heading: string = ''
  @Input('error_name') error_name: any
  @Input('selectedObject') selectedObject: any
  @Input('pageLevel') pageLevel = false;
  /** Raw rows backing the page-level summary — rendered in the "+N" breakdown popup. */
  @Input('breakdownData') breakdownData: any[] = [];
  @ViewChild('fs') fs!: ElementRef;
  isActive = false;
  noData:boolean=false;
  slopeFormattedData = [];
  slopeChartFormattedData: any = [];
  iconList: any[] = []
  @HostBinding('class.is-fullscreen') isFullscreen = false;
  SlopeChartData: any=[];
  props: any;
  divId: any = 'slopeChartDiv_' + Math.random().toString(36).slice(2, 11);
  hiddenLines: Set<string> = new Set();
  dataTurn: number = 0
  renderLinePopup: any = false
  initiateChart: boolean = false
  showBy: any
  isTooltip: boolean = false
  mytooltipData: any
  value1: any = "Business KPIs"
  value2: any = "Data Quality"
  kpiKeys!:any[]
  lineCount:any
  tooltiptype: any
  hei: number = 0;
  @ViewChild("showMoreData", { static: true }) showMoreData!: ElementRef;
  @ViewChild('slopeChartCustomTooltip') slopeChartCustomTooltip!: ElementRef | any;
  constructor(public filterService: FilterService, private dataService: DataService, private container: ElementRef, private currency: CurrencyPipe, private newFilterService: NewFilterService, private dialogService: DialogService, private dynamicCustomTooltipService: DynamicCustomTooltipService, private viewContainerRef: ViewContainerRef,private dataAggregation: DataAggregationService, private dialog: MatDialog) {
    this.filterService.filterQuery.subscribe((query: any) => {
      this.start()
    })
  }
  @HostListener('fullscreenchange', ['$event'])
  @HostListener('webkitfullscreenchange', ['$event'])
  @HostListener('mozfullscreenchange', ['$event'])
  @HostListener('MSFullscreenChange', ['$event'])
  screenChange(event: any) {
    // Browser fires both fullscreenchange AND resize during the transition. Cancel the
    // resize-debounce so we don't replot twice (which compounded the lag with the simulation).
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = null;
    }
    const fsEl = document.fullscreenElement
      || (document as any).webkitFullscreenElement
      || (document as any).mozFullScreenElement
      || (document as any).msFullscreenElement;
    if (!fsEl) {
      this.closeFullscreen();
    } else if (this.fs?.nativeElement && fsEl === this.fs.nativeElement) {
      this.isFullscreen = true;
      this.isActive = true;
      if (this.props) {
        this.props.chartHeight = (window.screen?.height || window.innerHeight) - 60;
      }
      this.schedulePlot();
    }
  }

  private forceSim: any = null;
  private plotScheduled: boolean = false;
  private schedulePlot(): void {
    if (this.plotScheduled) return;
    this.plotScheduled = true;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      this.plotScheduled = false;
      if (this.initiateChart && this.props && this.SlopeChartData?.length > 0) {
        this.plotChart();
      }
    }));
  }

  private resizeTimer: any = null;
  @HostListener('window:resize')
  onResize(): void {
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
    this.resizeTimer = setTimeout(() => {
      if (this.initiateChart && this.props && this.SlopeChartData?.length > 0) {
        this.plotChart();
      }
    }, 250);
  }

//loade Method
isLoading = false;
  
  Object = Object;
  Number = Number;

  formatLabel(key: string): string {
    if (!key) return '';
    return key
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }
  
async stop(ms: number): Promise<void> {
  return new Promise<void>(resolve => setTimeout(resolve, ms));
}
start() { this.isLoading = true;}

  closeFullscreen(): void {
    this.isFullscreen = false;
    if (this.props) { this.props.chartHeight = 550; }
    this.isActive = false;
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
    this.schedulePlot();
  }
  totalTooltipData: any = []
  showMore: boolean = false
  private hideTooltipTimer: any = null
  private showTooltip(myType: any, myData: any, myX: any, myY: any, chartWidth: any, chartHeight: any, event: any): void {
    if (this.hideTooltipTimer) {
      clearTimeout(this.hideTooltipTimer);
      this.hideTooltipTimer = null;
    }
    let showMoreCount:any =this.lineCount.length+2
    this.showMore = false
    this.tooltiptype = myType
    this.mytooltipData = myData
    this.hei = 0
    this.dataTurn = 0
    this.hei = chartHeight - myY
    this.dataTurn = chartWidth - myX
    let value: any = []

    if (this.item.config.chart_type == 'scorecard' && this.tooltiptype != "sp") {

      this.kpiKeys.forEach(key => {
        value[key] = [];
      });

      // Dynamic condition logic
      myData.values.forEach((element: any) => {
        this.kpiKeys.forEach(key => {
          if ( element[2] == key) {
            value[key].push(element);
          }
        });
      });
      this.mytooltipData.values = value

    }
    else {
      const copiedData = myData
      this.totalTooltipData = copiedData;
      this.mytooltipData = JSON.parse(JSON.stringify(copiedData));

      if (copiedData.values.length > showMoreCount) {
        this.showMore = true;
        const data1 = copiedData.values.slice(0, showMoreCount);
        this.mytooltipData.values = data1;
      } else {
        this.showMore = false;
      }
    }

    this.isTooltip = true
    if (this.dynamicCustomTooltipService) {
      this.dynamicCustomTooltipService.showTooltip(this.slopeChartCustomTooltip, this.viewContainerRef, event, true);
    }
  }

  /** Only the dot ('sp') tooltip renders the clickable "more" link / close icon. */
  private get isInteractiveTooltip(): boolean {
    return this.showMore && this.tooltiptype == 'sp';
  }

  // Always hides on mouseout. An interactive tooltip gets a longer grace period so the
  // pointer can travel onto it (keepTooltipOpen cancels the hide; leaving it hides again).
  hideTooltip(myType?: any): void {
    if (this.hideTooltipTimer) {
      clearTimeout(this.hideTooltipTimer);
    }
    this.hideTooltipTimer = setTimeout(() => this.closeTooltip(), this.isInteractiveTooltip ? 300 : 120);
  }

  keepTooltipOpen(): void {
    if (this.isInteractiveTooltip && this.hideTooltipTimer) {
      clearTimeout(this.hideTooltipTimer);
      this.hideTooltipTimer = null;
    }
  }

  closeTooltip(): void {
    if (this.hideTooltipTimer) {
      clearTimeout(this.hideTooltipTimer);
      this.hideTooltipTimer = null;
    }
    if (this.isTooltip) {
      this.isTooltip = false
      this.dynamicCustomTooltipService.hideTooltip();
    }
  }

  ngOnDestroy(): void {
    this.closeTooltip();
    this.forceSim?.stop();
  }

  ngOnInit(): void {
      this.start()
    this.iconList = this.item.config.icon ? this.item.config.icon : this.iconList
    this.initiateCharts();

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']?.currentValue != changes['data']?.previousValue && this.initiateChart) {
      // this.formatPercentageData(this.data);
      this.getSlopeChartData();

    }
  }

  openDialog() {
    this.closeTooltip()
    this.dialogService.openDialog(this.showMoreData, '300px')
  }

  /**
   * Opens the IDN-breakdown popup grid (shared BasicPopupGridComponent) with
   * all the raw rows behind the page-level summary. The grid is rendered from
   * local `breakdownData` (no API call) and sorted descending by total
   * cancelled. Triggered by the "+N" chip next to the summary values.
   */
  openBreakdownPopup(): void {
    const rows = Array.isArray(this.breakdownData) ? this.breakdownData : [];
    if (rows.length === 0) { return; }

    const rowData = [...rows].sort(
      (a: any, b: any) => (Number(b?.canceled_patient_count) || 0) - (Number(a?.canceled_patient_count) || 0)
    );

    const dialogData: BasicPopupGridDialogData = {
      heading: this.heading || 'IDN Breakdown',
      rowData,
      pageSize: 8,
      columnDefs: [
        { field: 'canceled_patient_count', headerName: 'Total Cancelled',      textAlign: 'left', format: 'number' },
        { field: 'catgry_name',            headerName: 'Top Reason',           textAlign: 'left', format: 'string' },
        { field: 'source_name',            headerName: 'Under Performing IDN', textAlign: 'left', format: 'string' },
      ],
    };

    this.dialog.open(BasicPopupGridComponent, {
      data: dialogData,
      panelClass: 'scraii-bgrid-list-dialog',
      width: '50vw',
      maxWidth: '765px',
      height: '80vh',
      disableClose: false,
    });
  }
//  d3 chart initial structure
  initiateCharts(): void {
    // only need to call this once on initialisation
    const myChart = this;
    const myClass = myChart.divId;

    const containerEl = myChart.slopeChartContainer?.nativeElement;
    if (!containerEl) { return; }

    const mySvg = d3.select(containerEl)
      .append('svg')
      .attr('id', 'svg_' + myClass)
      .attr('width', '100%')
      .attr('position', 'absolute')
      .style('background-color', 'white');

    mySvg
      .append("defs")
      .append("linearGradient")
      .attr("id", "kpiGradient");

    mySvg.append("g").attr("id", "barGroup");
    mySvg.append("g").attr("id", "lineGroup");
    this.initiateChart = true
  }
// chart svg  plotChart rendering 
  plotChart(): void {
    const myChart = this;
    const myClass = myChart.divId;
    const containerEl = myChart.slopeChartContainer?.nativeElement;
    if (!containerEl) { return; }
    let mySvg: any = d3.select(containerEl).select('#svg_' + myClass);
    if (mySvg.empty()) {
      myChart.initiateCharts();
      mySvg = d3.select(containerEl).select('#svg_' + myClass);
      if (mySvg.empty()) { return; }
    }
    let width: any =  mySvg.node().getBoundingClientRect().width;
    let height = myChart.props.chartHeight;
    const margins = { left: 0, right: 0, top: 70, bottom: 28, gradient: 20} ;
    const kpiColWidth = 44;
    const minKpiColWidth = 118;
    const dotRadius = 6;
    const kpiLabelLineHeight = 14; // ~1.2x the 12px bold header font
    const kpiLabelMaxLines = 4;
    let chartHeight = height - margins.top - margins.bottom;
    const columnVars: any = [];
    const columnFormats: any = {};
    const columnDirection: any = {};
    let chartData: any = []
    let columnSet: any = new Set();
    let lineSet: any = new Set();
    let allColumns: any = [];
    let columnsGroups: any = {};
    let dataByKpi: any = {};
    let kpiCatGroups: any = {};
    if(!myChart.props.groupVar){myChart.props.showGroups = false};
    myChart.SlopeChartData.forEach((d: any) => {
        const myGroupVar = !myChart.props.groupVar ? "" : (d[myChart.props.groupVar] ?? "");
        if(columnsGroups[myGroupVar] === undefined){
          columnsGroups[myGroupVar] = new Set();
        }
        columnSet.add(myGroupVar);
        columnsGroups[myGroupVar].add(d[myChart.props.kpiVar])
        lineSet.add(d[myChart.props.lineVar])
    });
    columnSet = Array.from(columnSet);
    // Order bars to match the keys in column_fields_config; unknown keys keep their natural order at the end.
    const cfgKeyOrder = Object.keys(myChart.item?.config?.column_fields_config || {});
    const cfgOrderIdx = new Map<string, number>();
    cfgKeyOrder.forEach((k, i) => cfgOrderIdx.set(k, i));
    const sortByCfg = (cols: any[]) => cols.slice().sort((a: any, b: any) => {
      const ai = cfgOrderIdx.has(a) ? (cfgOrderIdx.get(a) as number) : Number.MAX_SAFE_INTEGER;
      const bi = cfgOrderIdx.has(b) ? (cfgOrderIdx.get(b) as number) : Number.MAX_SAFE_INTEGER;
      return ai - bi;
    });
    columnSet.forEach((d: any) => {
        const orderedCols = sortByCfg(Array.from(columnsGroups[d]));
        columnVars.push({
          name: d,
          columns: orderedCols
        })
        allColumns = allColumns.concat(orderedCols);
    })
    this.kpiKeys=columnSet
    lineSet = Array.from(lineSet);
    this.lineCount=lineSet
    lineSet.forEach((d: any) => {
        let myEntry: any = {};
        myEntry[myChart.props.lineVar] = d;
        allColumns.forEach((c: any) => {
          if(dataByKpi[c] === undefined){dataByKpi[c] = {}};
          const matchingRow = myChart.SlopeChartData.find((f: any) => f[myChart.props.kpiVar] === c && f[myChart.props.lineVar] === d);
          if(matchingRow === undefined){
            console.log("ALERT - data missing!!")
          } else {
            dataByKpi[c][d] = matchingRow[myChart.props.valueVar];
            myEntry[c] = matchingRow[myChart.props.valueVar];
          }
        })
        chartData.push(myEntry);
    })
    allColumns.forEach((d: any) => {
      const firstMatching = myChart.SlopeChartData.find((f: any) => f[myChart.props.kpiVar] === d);
      // Synthesized dummy zero-rows may not carry a kpi_format — default to ","
      // so downstream `.includes('/+')` calls don't throw.
      const fmt = firstMatching ? firstMatching[myChart.props.formatVar] : undefined;
      columnFormats[d] = (typeof fmt === 'string' && fmt.length > 0) ? fmt : ',';
      // Rows without numeric range_start/range_end (e.g. custom kpiVar/valueVar configs) would give a
      // NaN domain → NaN line paths. Fall back to 0 .. max value of this KPI.
      const toNum = (v: any) => (v === null || v === undefined || v === '') ? NaN : +v;
      let rStart = firstMatching ? toNum(firstMatching[myChart.props.rangeVars[0]]) : 0;
      let rEnd = firstMatching ? toNum(firstMatching[myChart.props.rangeVars[1]]) : 100;
      if (!isFinite(rStart) || !isFinite(rEnd) || rStart === rEnd) {
        const kpiValues = myChart.SlopeChartData
          .filter((f: any) => f[myChart.props.kpiVar] === d)
          .map((f: any) => +f[myChart.props.valueVar])
          .filter((v: any) => isFinite(v));
        const dataMin = Math.min(0, ...kpiValues);
        const dataMax = kpiValues.length ? Math.max(...kpiValues) : 0;
        rStart = isFinite(rStart) ? rStart : dataMin;
        rEnd = isFinite(rEnd) && rEnd !== rStart ? rEnd : (dataMax > rStart ? dataMax : rStart + 100);
      }
      columnDirection[d] = [rStart, rEnd];
    })
    mySvg.attr("height", height);
    mySvg.select("#kpiGradient")
      .attr("x1", "0%")
      .attr("x2", "0%")
      .attr("y1", "0%")
      .attr("y2", "100%");

    const gradientStops = [
      ["#FAE7ECFF",0],
      ["#FAE7EC20",50],
      ["#EBFAF220",50],
      ["#EBFAF2FF",100]
    ]

    mySvg.select("#kpiGradient")
      .selectAll("stop")
      .data(gradientStops)
      .enter()
      .append("stop")
      .style("stop-color",  (d: any)  => d[0])
      .attr("offset", (d: any) => d[1] + "%");

    let kpiColumns: any = [];
    const kpiGroups: any = {};
    columnVars.forEach((d: any) => {
      kpiGroups[d.name] = d.columns;
      d.columns.forEach((c: any) => kpiCatGroups[c] = d.name);
      kpiColumns = kpiColumns.concat(d.columns);
    })

    // KPI headers wrap upward from just above the bars, between the legend (top 40px)
    // and the bars. Grow margins.top to fit the tallest header so long names like
    // "MPR (Medication Possession Ratio)" can't run into the axis labels / dots.
    const legendAreaHeight = 40;
    const kpiLabelY = -10;
    const kpiLabelWidth = Math.max(20, width / Math.max(kpiColumns.length, 1) - 25);
    const measureText: any = mySvg.append('text')
      .attr('font-weight', '700')
      .attr('font-size', '12')
      .attr('font-family', 'Poppins')
      .attr('visibility', 'hidden');
    const maxKpiLabelLines = Math.max(1, ...kpiColumns.map((d: any) =>
      splitLabelLines(measureText.node(), String(d), kpiLabelWidth).length));
    measureText.remove();
    // legend + gap above bars + first-line ascent (~12px) + extra lines + 4px breathing room
    margins.top = Math.max(70, legendAreaHeight - kpiLabelY + 12 + (maxKpiLabelLines - 1) * kpiLabelLineHeight + 4);
    chartHeight = height - margins.top - margins.bottom;

    const kpiScales: any = {};
    const kpiScaleTicks: any = {};
    kpiColumns.forEach((d: any) => {
      const columnMax: any = d3.max(myChart.SlopeChartData.filter((f: any) => f[myChart.props.kpiVar] === d),
        (m: any) => +m[myChart.props.valueVar]);
      const topIndex = columnDirection[d][0] < columnDirection[d][1] ? 1 : 0;
      // Only shrink the axis when there's actual data — when columnMax is 0
      // (e.g. only dummy zero-rows), keep the configured range so the bars/ticks render.
      if(columnMax > 0 && (columnMax/columnDirection[d][topIndex]) < 0.85){
        columnDirection[d][topIndex] = columnFormats[d]==".0%"? Math.ceil(columnMax/100) :Math.ceil(columnMax/100) * 100
      }
      kpiScales[d] = d3.scaleLinear()
        .domain(columnDirection[d])
        .range([height - margins.top - (margins.gradient * 2) - margins.bottom,0])
        .nice();
      ;
      const start: any = columnDirection[d][topIndex === 1 ? 0 : 1];
      const stop: any = columnDirection[d][topIndex];
      let step: any = (stop - start)/5;
      if(start > stop){ step = -step}
      kpiScaleTicks[d] = Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
    })
    const lineVars: any = [];
    chartData.forEach((d: any) => lineVars.push(d[myChart.props.lineVar]));
    let lineData: any = [];
    const columnData: any = [];
    lineVars.forEach((d: any, i: any) => {
      const myLineData = chartData.find((f: any) => f[myChart.props.lineVar] === d);
      const currentLine: any = [];
      kpiColumns.forEach((k: any) => {
        // Skip 0-valued points so placeholder/empty bars don't pull the line down.
        // Also skip non-numeric values — they would produce NaN positions in the line path.
        const numVal = myLineData[k] === undefined || myLineData[k] === null || myLineData[k] === '' ? NaN : +myLineData[k];
        const yPos = kpiScales[k](numVal);
        if(isFinite(numVal) && numVal !== 0 && isFinite(yPos)){
          currentLine.push({
            xVar: k,
            yVal: numVal,
            yPosition: yPos
          })
        }
        columnData.push({
          kpi: k,
          value: myLineData[k]
        })
      })
      // Drop lines that have no real points (e.g. the synthesized line when there's no data).
      if(currentLine.length === 0){ return; }
      lineData.push([d, currentLine, myChart.props.colors[i], false])
    })

    // Skip the average line entirely when the dataset has no real values
    // (e.g. only synthesized zero-rows used to render empty bars).
    const hasAnyRealValue = columnData.some((f: any) => f.value !== 0 && f.value !== undefined && f.value !== null);
    if(myChart.props.showAverage === true && hasAnyRealValue){
      const currentLine: any = [];
      kpiColumns.forEach((d: any) => {
        const myColumnData = columnData.filter((f: any) => f.kpi === d);
        const myMean: any = d3.mean(myColumnData, (m: any) => {
          const v = m.value === null || m.value === '' ? NaN : +m.value;
          return isFinite(v) ? v : undefined;
        });
        const yPos = kpiScales[d](myMean);
        if (myMean === undefined || !isFinite(yPos)) { return; }
        currentLine.push({
          xVar: d,
          yVal: myMean,
          yPosition: yPos
        })
      })
      lineData.push(["Network Average", currentLine, myChart.props.averageColor, true])
    }
    myChart.slopeFormattedData = lineData;
    // if(width < (kpiColumns.length * minKpiColWidth)){
    //   width = kpiColumns.length * minKpiColWidth;
    //   mySvg.attr("width", width)
    // }
    const xScale: any = d3.scaleBand().domain(kpiColumns).range([0,width]);

    const barGroup = mySvg.select('#barGroup')
      .selectAll('.barsGroup')
      .data(kpiColumns)
      .join((group: any): any => {
        const enter = group.append('g').attr('class', 'barsGroup');
        enter.append('rect').attr('class', 'kpiBar');
        enter.append('text').attr('class', 'kpiBarLabel');
        enter.append('g').attr('class', 'yAxis');
        enter.append('g').attr('class', 'yAxisLineGroup');
        return enter;
      });

    barGroup.attr("transform", (d: any) => "translate(" + (margins.left + xScale(d) + xScale.bandwidth()/1.75 - kpiColWidth/2) + ","
    + margins.top + ")")

    barGroup.select(".kpiBarLabel")
      .attr("transform", "translate(" + ( kpiColWidth/2) + "," + kpiLabelY + ")")
      .attr('font-weight', '700')
      .attr('font-size', '12')
      .attr('font-family', 'Poppins')
      .attr("text-anchor", "middle")
      .attr("height", chartHeight)
      .attr("fill", "#000000")
      .text((d: any,i:any) => d)
      .call(wrap, kpiLabelWidth);

    barGroup.select(".kpiBar")
      .attr("width", kpiColWidth)
      .attr("height", chartHeight)
      .attr("fill", "url(#kpiGradient)");

    barGroup.select(".yAxis")
      .attr("id", (d: any) => getCorrectLabel(d))
      .attr("transform", (d: any) => "translate(0," + margins.gradient + ")")
      .each(function (this: any, d: any) {
        const myGroup: any = d3.select(this);
        myGroup.call(d3.axisLeft(kpiScales[d])
          .tickValues(kpiScaleTicks[d])
          .tickFormat((f: any) => {
            if (columnFormats[d].includes('/+')) {
                const [prefix, format, suffix] = columnFormats[d].split('/+');
                return `${prefix||''}${axisTickFormat(format)(f)}${suffix||''}`;
            } else {
                return axisTickFormat(columnFormats[d])(f);
            }
        })
        )
    });
   
    const axisLineGroup = barGroup.select('.yAxisLineGroup')
      .selectAll('.axisLines')
      .data((d: any) => {
        const myData = kpiScaleTicks[d].map((m: any) => m = kpiScales[d](m))
        return myData;
      })
      .join((group: any): any => {
        const enter = group.append('g').attr('class', 'axisLines');
        enter.append('line').attr('class', 'axisLine');
        return enter;
      });

    axisLineGroup.select(".axisLine")
      .attr("x1", 0)
      .attr("x2", kpiColWidth)
      .attr("y1", (d: any) => margins.gradient + d)
      .attr("y2", (d: any) => margins.gradient + d)
      .attr("stroke", "#8A98AB")
      .attr("stroke-dasharray","4,4")
      .attr("stroke-width", 1);

    mySvg.selectAll(".yAxis text")
      .attr('font-weight', '700')
      .attr('font-size', '12')
      .attr('font-family', 'Poppins')
      .attr('fill','#101D42');

    mySvg.selectAll(".yAxis path")
      .attr("display", "none");

    mySvg.selectAll(".yAxis line")
      .attr("stroke", "#8A98AB");

    const line = d3.line()
      .x((d: any) => d.x + xScale(d.xVar))
      .y((d: any) => d.y);

    let allDots: any = [];
    lineData.forEach((d: any) => allDots = allDots.concat(d[1]));

    let currentCount = 0;
   columnVars.forEach((d: any ) => {
      d.xPosition = currentCount * xScale.bandwidth()
      currentCount += d.columns.length;
    })

    const groupGroup = mySvg
      .selectAll('.groupsGroup')
      .data(columnVars)
      .join((group: any): any => {
        const enter = group.append('g').attr('class', 'groupsGroup');
        enter.append('rect').attr('class', 'groupsRect');
        enter.append('text').attr('class', 'groupsRectLabel');
        enter.append('line').attr('class', 'groupsRectLine');
        return enter;
      });

    groupGroup.select(".groupsRectLine")
      .attr("stroke", (d: any, i: any) => i > 0 ? "#8A98AB" : "transparent")
      .attr("stroke-dasharray", "2,2")
      .attr("x1", (d: any) => d.xPosition)
      .attr("x2", (d: any) => d.xPosition)
      .attr("y1", margins.top)
      .attr("y2", height)

    groupGroup.select(".groupsRect")
      .attr("x", (d: any) => d.xPosition)
      .attr("y", height - margins.bottom)
      .attr("width", (d: any) => xScale.bandwidth() * d.columns.length)
      .attr("height", myChart.props.showGroups === true ? margins.bottom : 0)
      .attr("fill", "#E8EDF3")

    groupGroup.select(".groupsRectLabel")
      .attr("x", (d: any) => d.xPosition + (xScale.bandwidth() * d.columns.length)/2)
      .attr("y", height - (margins.bottom/2) + 5)
      .attr('fill', '#101D42')
      .attr('font-weight', '700')
      .attr('font-size', '12')
      .attr('font-family', 'Poppins')
      .attr('text-anchor', 'middle')
      .text((d: any) => myChart.props.showGroups === true ? d.name : "");



    const lineGroup = mySvg.select('#lineGroup')
      .selectAll('.linesGroup')
      .data(lineData)
      .join((group: any): any => {
        const enter = group.append('g').attr('class', 'linesGroup');
        enter.append('path').attr('class', 'linePath');
        enter.append('path').attr('class', 'linePathMouseover');
        enter.append('g').attr('class', 'dotsGroup');
        return enter;
      });

    lineGroup.select(".linePath")
      .attr("id", (d: any, i: any) => "linePath" + i)
      .attr("stroke", (d: any) => d[2])
      .attr("stroke-width", 1)
      .attr("stroke-dasharray", (d: any) => d[3] === true ? "2,2" : "")
      .attr("fill", "none")
      .attr("transform", "translate(" + (margins.left + xScale.bandwidth()/2 + kpiColWidth/2)
        + "," + (margins.top + margins.gradient) + ")");

    lineGroup.select('.dotsGroup')
      .attr("stroke", (d: any) => d[2])
      .attr("stroke-dasharray", (d: any) => d[3] === true ? "2,2" : "")
      .attr("fill", (d: any) => d[2])
      .attr("transform", "translate(" + (margins.left + xScale.bandwidth()/2 + kpiColWidth/2)
        + "," + (margins.top + margins.gradient) + ")");

    lineGroup.select(".linePathMouseover")
      .attr("id", (d: any, i: any) => "linePath" + i)
      .attr("stroke", "transparent")
      .attr("stroke-width", 2)
      .attr("fill", "none")
      .attr("transform", "translate(" + (margins.left + xScale.bandwidth()/2 + kpiColWidth/2)
        + "," + (margins.top + margins.gradient) + ")")
      .on("mouseover", (event: any, d: any) => {
          d3.select(".linePath#" + event.currentTarget.id)
            .attr("stroke-width", 2);
            const tooltipValues: any = d[1].map((m: any) => {
              const xVar = m.xVar;
              const yVal = m.yVal;
              const formatString = columnFormats[xVar];
          
              let formattedValue;
          
              if (formatString.includes('/+')) {
                  // Extract prefix, format, and suffix
                  const [prefix = '', format = '', suffix = ''] = formatString.split('/+');
                  formattedValue = `${prefix}${d3.format(format)(yVal)}${suffix}`;
              } else {
                  // Apply standard formatting
                  formattedValue = d3.format(formatString.includes("%") ? formatString : ",")(yVal);
              }
          
              return [xVar, formattedValue, kpiCatGroups[xVar]];
          });
          
        const tooltipData = {name: d[0], color: d[2], values: tooltipValues};
        myChart.showTooltip('slopeChart', tooltipData, event.offsetX, event.offsetY, width, height, event);
      })
      .on("mouseout", (event: any) => {
        d3.selectAll(".linePath").attr("stroke-width", 1);
        myChart.hideTooltip('sp');
      });

    const dotGroup = lineGroup.select('.dotsGroup')
      .selectAll('.lineDotsGroup')
      .data((d: any, i: any) => {
        d[1].map((m: any) => {
          m.color = d[2];
          m.lineId =  "linePath" + i;
          m.selected = d[0];
        })
        return d[1]})
      .join((group: any): any => {
        const enter = group.append('g').attr('class', 'lineDotsGroup');
        enter.append('circle').attr('class', 'backgroundDotCircle');
        enter.append('circle').attr('class', 'dotCircle');
        return enter;
      });

    dotGroup.select(".backgroundDotCircle")
      .attr("fill", "white")
      .attr("stroke-width", 0)
      .attr("r", dotRadius)
      .attr("cx", (d: any) => xScale(d.xVar));

    dotGroup.select(".dotCircle")
      .attr("fill-opacity", 0.2)
      .attr("stroke-width", 2)
      .attr("r", dotRadius)
      .attr("cx", (d: any) => xScale(d.xVar))
      .on("mouseover", (event: any, d: any) => {
        d3.select(".linePath#" + d.lineId)
          .attr("stroke-width", 2);
          let tooltipValues = Object.keys(dataByKpi[d.xVar]).map((m: any) => {
            const formatString = columnFormats[d.xVar];
            const value = dataByKpi[d.xVar][m];
        
            let formattedValue;
        
            if (formatString.includes('/+')) {
                // Extract prefix, format, and suffix
                const [prefix = '', format = '', suffix = ''] = formatString.split('/+');
                formattedValue = `${prefix}${d3.format(format)(value)}${suffix}`;
            } else {
                // Apply standard formatting (with % check)
                formattedValue = d3.format(formatString.includes("%") ? formatString : ",")(value);
            }
        
            return [m, formattedValue, lineData.find((f: any) => f[0] === m)?.[2]];
        });
        
        const tooltipData = {xVar: d.xVar, xGroup: kpiCatGroups[d.xVar], values: tooltipValues};
        if(myChart.props.showAverage){
          const averageValues = lineData.find((f: any) => f[0] === 'Network Average');
          const avgPoint = averageValues?.[1].find((f: any) => f.xVar === d.xVar);
          if(averageValues && avgPoint){
            tooltipData.values.push([
              "Network Average",
              (function() {
                  const formatString = columnFormats[d.xVar];
                  const value = avgPoint.yVal;

                  if (formatString.includes('/+')) {
                      // Extract prefix, format, and suffix
                      const [prefix = '', format = '', suffix = ''] = formatString.split('/+');
                      return `${prefix}${d3.format(format)(value)}${suffix}`;
                  } else {
                      // Apply standard formatting (with % check)
                      return d3.format(formatString.includes("%") ? formatString : ",")(value);
                  }
              })(),
              averageValues[2]
            ]);
          }
        }
        tooltipData.values = tooltipData.values.sort((a: any,b: any) =>  a[0] == d.selected ? -1 : b[0] == d.selected ? 1 : 0);

        myChart.showTooltip('sp', tooltipData, event.offsetX, event.offsetY, width, height, event);
      })
      .on("mouseout", (event: any, d: any) => {
        d3.selectAll(".linePath").attr("stroke-width", 1);
        myChart.hideTooltip('slopeChart');
      });


    // Stop any in-flight simulation from a prior render (fullscreen toggles + resize used to
    // stack simulations, all writing to the DOM each tick — that was the main source of lag).
    if (myChart.forceSim) {
      myChart.forceSim.stop();
    }
    myChart.forceSim = d3.forceSimulation(allDots)
      .force("x", d3.forceX((d: any) =>  0).strength(0.3))
      .force("y", d3.forceY((d: any) => d.yPosition).strength(1))
      .force("collision", d3.forceCollide(dotRadius * 0.6))
      .on("tick", ticked);
      // sorting the legend
      lineData = lineData.sort((a:any, b:any) => a[0].localeCompare(b[0]));
      console.log(lineData);
    drawLegend(lineData);
    function ticked(){

      mySvg.selectAll(".linePath")
        .attr("d", (d: any) => line(d[1]));

      mySvg.selectAll(".linePathMouseover")
        .attr("d", (d: any) => line(d[1]));

      mySvg.selectAll(".dotCircle")
        .filter((d: any) => !isNaN(d.y))
        .attr('transform', (d: any) => 'translate(' + d.x + ',' + d.y + ')');

      mySvg.selectAll(".backgroundDotCircle")
        .filter((d: any) => !isNaN(d.y))
        .attr('transform', (d: any) => 'translate(' + d.x + ',' + d.y + ')');

    }


    function drawLegend(legendData: any){

      const arrowBtnWidth = 24;
      const arrowGap = 10;
      const legendAreaY = 0;
      const scrollStartX = arrowBtnWidth + arrowGap;
      const scrollEndX = Math.max(scrollStartX + 1, width - arrowBtnWidth - arrowGap);
      const scrollWidth = scrollEndX - scrollStartX;
      const clipStartX = arrowBtnWidth;
      const clipEndX = width - arrowBtnWidth;

      let defs: any = mySvg.select('defs');
      if (defs.empty()) defs = mySvg.append('defs');
      let clip: any = defs.select('#legendClip_' + myClass);
      if (clip.empty()) {
        clip = defs.append('clipPath').attr('id', 'legendClip_' + myClass);
        clip.append('rect');
      }
      clip.select('rect')
        .attr('x', clipStartX)
        .attr('y', legendAreaY)
        .attr('width', Math.max(1, clipEndX - clipStartX))
        .attr('height', 40);

      let legendContainer: any = mySvg.select('.legendContainer_' + myClass);
      if (legendContainer.empty()) {
        legendContainer = mySvg.append('g').attr('class', 'legendContainer_' + myClass);
        legendContainer.attr('clip-path', 'url(#legendClip_' + myClass + ')');
        legendContainer.append('g').attr('class', 'legendScroll_' + myClass);
      }
      const legendScroll: any = legendContainer.select('.legendScroll_' + myClass);

      const legendGroup = legendScroll
        .selectAll('.legendGroup' + myClass)
        .data(legendData)
        .join((group: any) => {
          const enter = group.append('g').attr('class', 'legendGroup' + myClass);
          enter.append('circle').attr('class', 'legendCircle');
          enter.append('text').attr('class', 'legendLabel');
          return enter;
        });

      legendGroup.attr("transform", "translate(" + (scrollStartX) + ",15)");

      legendGroup
        .style('cursor', 'pointer')
        .on('click', null)
        .on('click', (_event: any, d: any) => {
          const name = d[0];
          if (myChart.hiddenLines.has(name)) {
            myChart.hiddenLines.delete(name);
          } else {
            myChart.hiddenLines.add(name);
          }
          applyLineVisibility();
        });

      legendGroup.select('.legendCircle')
        .attr('id', (d: any) => 'circle_legendItem' + getCorrectLabel(d[0]))
        .attr('fill', (d: any) => d[2])
        .attr('stroke', (d: any) => d[2])
        .attr('stroke-width', 2)
        .attr('stroke-dasharray', (d: any) => d[3] === true ? "4,2" : "")
        .attr('r', dotRadius);

      legendGroup.select('.legendLabel')
        .attr('id', (d: any) => 'legendItem' + getCorrectLabel(d[0]))
        .attr('y', 5)
        .attr('font-weight', '500')
        .attr('font-size', '12')
        .attr('font-family', 'Poppins')
        .text((d: any) => d[0].toUpperCase())

      applyLineVisibility();

      function applyLineVisibility() {
        mySvg.select('#lineGroup').selectAll('.linesGroup')
          .style('display', (dd: any) => myChart.hiddenLines.has(dd[0]) ? 'none' : null);

        legendGroup.select('.legendCircle')
          .attr('fill-opacity', (dd: any) => myChart.hiddenLines.has(dd[0]) ? 0 : 0.2)
          .attr('stroke-opacity', (dd: any) => myChart.hiddenLines.has(dd[0]) ? 0.4 : 1);

        legendGroup.select('.legendLabel')
          .attr('fill', (dd: any) => myChart.hiddenLines.has(dd[0]) ? '#8A98AB' : '#101D42')
          // .attr('text-decoration', (dd: any) => myChart.hiddenLines.has(dd[0]) ? 'line-through' : 'none');
      }

      let legendX = 0;
      legendScroll.selectAll('.legendGroup' + myClass).each(function(): any {
        //@ts-ignore
        const group = d3.select(this);
        const labelNode: any = group.select('.legendLabel').node();
        // Measure the SVG text directly. getComputedTextLength() is synchronous and
        // layout-independent (unlike getBoundingClientRect on a freshly-appended, clipped
        // node, which returns 0 before paint) and returns SVG user units that match the
        // chart's coordinate space. A 0/NaN width here was piling every label at x=0
        // (overlap) and zeroing maxScroll (so the scroll arrows never appeared).
        const myWidth: number = labelNode && typeof labelNode.getComputedTextLength === 'function'
          ? labelNode.getComputedTextLength()
          : 0;
        group.select('.legendLabel').attr('x', legendX + (dotRadius * 2));
        group.select('.legendCircle').attr('cx', legendX);
        legendX += (40 + myWidth);
      });

      const totalLegendWidth = legendX;
      const maxScroll = Math.max(0, totalLegendWidth - scrollWidth);
      const scrollStep = Math.max(80, scrollWidth * 0.6);

      let currentOffset = +(legendScroll.attr('data-offset') || 0);
      if (currentOffset > maxScroll) currentOffset = maxScroll;
      if (currentOffset < 0) currentOffset = 0;
      legendScroll.attr('data-offset', currentOffset);
      legendScroll.attr('transform', 'translate(' + (-currentOffset) + ',0)');

      ensureArrow('left', 0);
      ensureArrow('right', width - arrowBtnWidth);
      updateArrowVisibility();

      function ensureArrow(dir: 'left' | 'right', x: number) {
        const id = 'legendArrow_' + dir + '_' + myClass;
        let arrow: any = mySvg.select('#' + id);
        if (arrow.empty()) {
          arrow = mySvg.append('g').attr('id', id).style('cursor', 'pointer');
          arrow.append('rect')
            .attr('width', arrowBtnWidth).attr('height', 24)
            .attr('y', -2)
            .attr('fill', 'white')
            .attr('fill-opacity', 0.9);
          arrow.append('path')
            .attr('fill', '#1566DE').attr('stroke', '#1566DE')
            .attr('stroke-width', 1)
            .attr('stroke-linejoin', 'round');
        }
        arrow.attr('transform', 'translate(' + x + ',' + (legendAreaY + 6) + ')');
        arrow.select('path').attr('d', dir === 'left' ? 'M15,1 L5,10 L15,19 Z' : 'M9,1 L19,10 L9,19 Z');
        arrow.on('click', null).on('click', () => {
          let offset = +(legendScroll.attr('data-offset') || 0);
          offset = dir === 'left'
            ? Math.max(0, offset - scrollStep)
            : Math.min(maxScroll, offset + scrollStep);
          legendScroll.attr('data-offset', offset)
            .transition().duration(200)
            .attr('transform', 'translate(' + (-offset) + ',0)');
          updateArrowVisibility(offset);
        });
      }

      function updateArrowVisibility(nextOffset?: number) {
        const offset = nextOffset !== undefined ? nextOffset : +(legendScroll.attr('data-offset') || 0);
        const showArrows = maxScroll > 0;
        mySvg.select('#legendArrow_left_' + myClass)
          .style('display', showArrows && offset > 0 ? null : 'none');
        mySvg.select('#legendArrow_right_' + myClass)
          .style('display', showArrows && offset < maxScroll ? null : 'none');
      }
    }

    function getCorrectLabel(d: any) {
      // cheat as could not work out the regex
      let myString = d.split('');
      myString = myString.filter((f: any) => f !== ' ')
      myString = myString.filter((f: any) => f !== '(')
      myString = myString.filter((f: any) => f !== ')')
      myString = myString.filter((f: any) => f !== '-')
      myString = myString.join('');
      return myString
    }
 
    /**
     * Greedy word wrap measured with `textEl`'s font. Caps at kpiLabelMaxLines; the last
     * kept line is ellipsised when text is dropped (full label is in the <title>).
     */
    function splitLabelLines(textEl: SVGTextElement, label: string, width: number): string[] {
      const fits = (s: string) => {
        textEl.textContent = s;
        return textEl.getComputedTextLength() <= width;
      };
      const lines: string[] = [];
      let current = '';
      label.split(/\s+/).filter(Boolean).forEach((word) => {
        const candidate = current ? current + ' ' + word : word;
        if (!current || fits(candidate)) {
          current = candidate;
        } else {
          lines.push(current);
          current = word;
        }
      });
      if (current) lines.push(current);

      if (lines.length > kpiLabelMaxLines) {
        const kept = lines.slice(0, kpiLabelMaxLines);
        let last = kept[kpiLabelMaxLines - 1];
        while (last.length > 1 && !fits(last + '…')) {
          last = last.slice(0, -1).trimEnd();
        }
        kept[kpiLabelMaxLines - 1] = last + '…';
        return kept;
      }
      return lines;
    }

    // Lines grow upward so the last one always sits just above the bar.
    function wrap(text: any, width: any): void {
      text.each(function(this: SVGTextElement): any {
        const label = d3.select(this).datum() as any;
        const el = d3.select(this);
        el.selectAll('*').remove();
        const lines = splitLabelLines(this, String(label), width);
        el.text(null);
        lines.forEach((line, i) => {
          el.append('tspan')
            .attr('x', 0)
            .attr('dy', (i === 0 ? -(lines.length - 1) * kpiLabelLineHeight : kpiLabelLineHeight) + 'px')
            .text(line);
        });
        el.append('title').text(String(label));
      });
    }  this.stop(10).then(() => this.isLoading = false);

  }
// property & data for the chart
  getSlopeChartData() {
    // Re-render replaces the hovered nodes without firing mouseout — close the overlay too
    this.closeTooltip()
    // this.SlopeChartData=this.data
    if (this.item.config.chart_type == 'scorecard') {
      // 100198
      this.SlopeChartData = this.data

    } else {
      this.SlopeChartData = this.data
      // 100195
    }
      
    const cfg = this.item?.config;
    if(cfg?.['AggregationEnabled'] == true) {      
      // const { groups, summary } = this.getAvgBusinessHours( this.SlopeChartData, cfg);
      // this.SlopeChartData = groups;
      // Aggregate: total canceled_patient_count per source_name, then each (source, catgry) share of that total.
      const sourceTotals: { [src: string]: number } = {};
      const groupSums: { [key: string]: { source_name: string; catgry_name: string; sum: number } } = {};
      (this.SlopeChartData || []).forEach((row: any) => {
        const src = row.source_name;
        const cat = row.catgry_name;
        const cnt = +row.canceled_patient_count || 0;
        if (!src || !cat) return;
        sourceTotals[src] = (sourceTotals[src] || 0) + cnt;
        const key = src + '|' + cat;
        if (!groupSums[key]) {
          groupSums[key] = { source_name: src, catgry_name: cat, sum: 0 };
        }
        groupSums[key].sum += cnt;
      });
      this.SlopeChartData = Object.values(groupSums).map((g: any) => ({
        source_name: g.source_name,
        catgry_name: g.catgry_name,
        canceled_patient_count: sourceTotals[g.source_name] > 0 ? g.sum / sourceTotals[g.source_name] : 0
      }));
    
      const columnFieldsConfig = this.item.config.column_fields_config || {};
      const kpiVarKey = this.item.config.kpiVar || 'catgry_name';
      const lineVarKey = this.item.config.lineVar || (this.item.config.chart_type == 'scorecard' ? 'source_name' : 'brand_name');
      const valueVarKey = this.item.config.valueVar || 'canceled_patient_count';

      // Ensure every line (source/brand) has a row for every key in columnFieldsConfig.
      // Missing kpiVarKey values would otherwise drop bars from the chart — fill them with 0.
      // If there is no data at all, still emit one placeholder line so the config bars render.
      const expectedKeys = Object.keys(columnFieldsConfig);
      if (expectedKeys.length > 0) {
        let lineValues: any[] = Array.from(
          new Set((this.SlopeChartData || []).map((r: any) => r[lineVarKey]))
        ).filter((v: any) => v !== undefined && v !== null && v !== '');
        if (lineValues.length === 0) {
          lineValues = [''];
        }
        const existingPairs = new Set(
          (this.SlopeChartData || []).map((r: any) => r[lineVarKey] + '|' + r[kpiVarKey])
        );
        lineValues.forEach((line: any) => {
          expectedKeys.forEach((key: string) => {
            if (!existingPairs.has(line + '|' + key)) {
              const overrides = columnFieldsConfig[key] || {};
              const fmt = overrides.kpi_format || '';
              const isPercent = typeof fmt === 'string' && fmt.endsWith('%');
              this.SlopeChartData.push({
                [lineVarKey]: line,
                [kpiVarKey]: key,
                [valueVarKey]: 0,
                kpi_format: fmt,
                range_start: 0,
                range_end: isPercent ? 1 : 100,
                ...overrides
              });
            }
          });
        });
      }

      this.SlopeChartData = (this.SlopeChartData || []).map((row: any) => {
        const overrides = columnFieldsConfig[row[kpiVarKey]] || {};
        const fmt = overrides.kpi_format || row.kpi_format || '';
        // d3's "%" formats consume values in 0-1 (0.45 -> "45%"), so the y-axis
        // top must be 1 not 100 — otherwise bars render squished at the bottom.
        const isPercent = typeof fmt === 'string' && fmt.endsWith('%');
        return {
          ...row,
          range_start: 0,
          range_end: isPercent ? 1 : 100,
          ...overrides
        };
      });
    }
    this.data = this.SlopeChartData;
    // sessionStorage.setItem('sloapchartdata', JSON.stringify(this.data))
// console.log(this.data) 
    this.props = {
      chartHeight: this.isFullscreen ? 800 : 550,
      colors:["#E74028", "#2CB239", "#25D3EB", "#FFB039", "#1566DE", "#7848FF", "#7AD045", "#CB04DC", "#FA195C", "#9E0000", "#EACD37", "#DD630B", "#BCD03F", "#14BDA9", "#8A05F3", "#D9476A", "#2DADB6", "#E468C2", "#199CD4", "#0934CC",
        "#e74c3c", "#3498db", "#2ecc71", "#f1c40f", "#9b59b6",
        "#1abc9c", "#34495e", "#e67e22", "#16a085", "#d35400",
        "#2980b9", "#8e44ad", "#c0392b", "#27ae60", "#f39c12",
        "#7f8c8d", "#e74c3c", "#3498db", "#2ecc71", "#f1c40f",
        "#9b59b6", "#1abc9c", "#34495e", "#e67e22", "#16a085",
        "#d35400", "#2980b9", "#8e44ad", "#c0392b", "#27ae60",
        "#f39c12", "#7f8c8d", "#e74c3c", "#3498db", "#2ecc71",
        "#f1c40f", "#9b59b6", "#1abc9c", "#34495e", "#e67e22",
        "#16a085", "#d35400", "#2980b9", "#8e44ad", "#c0392b",
        "#27ae60", "#f39c12", "#7f8c8d",
      ],
       // ["#FF6636", "#655CF4", "#FFCD4A", "#2DC887", "#7BD437", "#D19806", "#BC4231"],
      lineVar: this.item.config.lineVar || (this.item.config.chart_type == 'scorecard' ? 'source_name' : 'brand_name'),
      kpiVar: this.item.config.kpiVar || 'kpi_name',
      valueVar: this.item.config.valueVar || 'kpi_value',
      groupVar: this.item.config.groupVar || null,
      formatVar: 'kpi_format',
      rangeVars: ['range_start', 'range_end'],
      showAverage: this.item.config.chart_type == 'scorecard' ? true : false, //boolean
      showGroups: false, //boolean — set below from the data's groupVar values
      averageColor: "#8A98AB"
    }
    // Show the bottom group bar (KPIs grouped by groupVar) whenever the rows carry a group value.
    const groupVar = this.props.groupVar;
    this.props.showGroups = !!groupVar && (this.SlopeChartData || []).some((row: any) =>
      row?.[groupVar] !== undefined && row?.[groupVar] !== null && row?.[groupVar] !== '');
    // @ts-ignore
    if (this.data.length > 0) {
      this.noData=false;
      setTimeout(() => {
        this.plotChart();
      }, 200);
      this.formatPercentageData(this.data);
    }else{
      this.noData=true; this.noDataNotifier.report('slope-chart');
      this.isLoading=false;
    }
  }
  // numberFormat
  numbedPipe(value: any) {
    if (typeof value === 'string') return value  
    if (value.includes('%')) return value
    if (value.includes(',')) {
      let val = value.replaceAll(/,/g, "");
      return this.currency.transform(val, '', '', '1.0-2');
    }


    return this.currency.transform(value, '', '', '1.0-2');
    //  return   this.numberpipe.transform(value)
  }
  removeUnderScore(value: string) {
    return value.replace(/_/g, ' ').toUpperCase()
  }
  formatPercentageData(data: any) {
    if (data && data.length > 0) {
      // const val: any = sessionStorage.getItem('sloapchartdata');
      // Copy each row — formatting kpi_value in place would turn the chart's numeric values
      // into strings ("23%", "45d") and drop those KPIs from the lines.
      this.slopeChartFormattedData = data.map((row: any) => ({ ...row }));
  
      this.slopeChartFormattedData.forEach((element: any) => {
        const formatString = element.kpi_format;
  
        if (formatString) {
          if (formatString.includes('/+')) {
            // Extract prefix, format, and suffix
            const [prefix = '', format = '', suffix = ''] = formatString.split('/+');
            
            // Format value based on the extracted format
            element.kpi_value = `${prefix}${d3.format(format)(element[this.props.valueVar || 'kpi_value'])}${suffix}`;
          } else if (formatString === ".0%") {
            // Special case for percentage formatting
            element.kpi_value = (element[this.props.valueVar || 'kpi_value'] * 100) + "%";
          } else {
            // Default formatting (if no '/+' exists)
            element.kpi_value = d3.format(formatString)(element[this.props.valueVar || 'kpi_value']);
          }
        }
  
        return element; // Return the formatted element
      });
    }
  }
    getAvgBusinessHours(rows: any[], cfg: any) {
      const config: AggregationConfig = {
        groupBy: cfg['aggregation_groupBy'] || ['source_name', 'catgry_name'],
        fields:  cfg['aggregation_fields'] || {
          canceled_patient_count: { source: 'canceled_patient_count', op: 'sum' },
          total_canceled:         { source: 'canceled_patient_count', op: 'sum', scope: 'all' },
        },
        computed: cfg['aggregation_computed'] || {
          pct_canceled: {
            op: 'percent',
            numerator:   'canceled_patient_count',
            denominator: 'total_canceled',
            round: 2,
            
          },
        },
      };
      const result = this.dataAggregation.aggregate(rows, config);
      return { groups: result.groups, summary: result.summary };
    }
}
